<template>
  <div class="focus">
    <div class="banner">
      <div class="video-wrap">
        <video autoplay loop class="video" muted v-on:canplay="canplay">
          <source src="../../../assets/img/mp4_1.mp4" type="video/mp4"/>
        </video>
        <div class="inner">
          <div class="text-wrap">
            <div class="slogn">全流程供应链金融解决方案</div>
            <div class="info">为中小微企业、乃至一些个体经营户解决融资难题</div>
            <div class="btn"><a :href="url" target="_blank">立即加入</a></div>
          </div>
          <ul class="advantage">
            <li>
              <div class="tit"><i class="jr-ico"></i><span>金融解决方案</span></div>
              <div class="des">助力金融行业，为企业解决难题</div>
            </li>
            <li>
              <div class="tit"><i class="ai-ico"></i><span>AI智能</span></div>
              <div class="des">科技赋能 海量处理 快捷方便</div>
            </li>
            <li>
              <div class="tit"><i class="qkl-ico"></i><span>区块链</span></div>
              <div class="des">点面相接 层层互通</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        vedioCanPlay: false,
        fixStyle: '',
        url:process.env.NODE_ENV!='production'?'http://192.168.50.151:81/register':'http://platform.ying-link.com/register'
      }
    },
    methods: {
      canplay(){
        this.vedioCanPlay = true;
      }
    },
  }
</script>

<style lang="less" scoped>
.focus{
  width:100vw;
  height:100vh;
  background: #e6ecf2;
  overflow: hidden;
  .banner{
    width:100vw;
    min-height:100vh;
    overflow: hidden;
    position: relative;
    .video-wrap{
      position: relative;
      width:100vw;
      min-height:100vh;
      overflow: hidden;
    }
    .video{
      min-width:100vw;
      min-height:100vh;
      position: relative;
      overflow: hidden;
    }
    .inner{
      width:100vw;
      height:100%;
      margin:0 auto;
      position: absolute;
      overflow: hidden;
      top:0;
      left:0;
      z-index:2;
      margin:0 auto;
      background: rgba(0, 0, 0, 0.6);
    }
    .text-wrap{
      position: absolute;
      top:30vh;
      left:0;
      width:100vw;
      text-align: center;
      .slogn{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 600;
        font-size: 80px;
        line-height: 90px;
        color: #fff;
        padding-bottom:9px;
      }
      .info{
        font-family: PingFang HK;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 60px;
        color: #fff;
        margin-bottom:20px;
      }
      .btn{
        margin:0 auto;
        a{
          display: inline-block;
          width: 87px;
          height: 28px;
          background: #0070FF;
          border-radius: 6px;
          font-family: PingFang HK;
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          color: #FFFFFF;
          text-align: center;
          line-height: 28px;
          cursor: pointer;
          padding:5px 10px;
        }
      }
    }
    .advantage{
      position: absolute;
      top:68vh;
      left:0;
      display: flex;
      align-items: center;
      width:100vw;
      text-align: center;
      justify-content:center;
      li{
        background: rgba(0,0,0,0.4);
        box-shadow: 0px 4px 6px rgba(217, 222, 251, 0.5);
        border-radius: 5px;
        width:182px;
        height:69px;
        margin-right:20px;
        .tit{
          display: flex;
          align-items: center;
          justify-content: center;
          padding:11px 0 9px 0;
          i{
            width:19px;
            height:19px;
            margin-right:10px;
          }
          .jr-ico{
            background: url(../../../assets/img/index/jr-ico.png) no-repeat 0 0;
            background-size:100% 100%;
          }
          .ai-ico{
            background: url(../../../assets/img/index/ai-ico.png) no-repeat 0 0;
            background-size:100% 100%;
          }
          .qkl-ico{
            background: url(../../../assets/img/index/qkl-ico.png) no-repeat 0 0;
            background-size:100% 100%;
          }
          span{
            font-family: PingFang HK;
            font-style: normal;
            font-weight: 500;
            font-size: 13px;
            color: #fff;
          }
        }
        .des{
          font-family: PingFang HK;
          font-style: normal;
          font-weight: 500;
          font-size: 8px;
          line-height: 11px;
          color: #B0BAC3;
          text-align: center;
        }
      }
    }
  }
}
@media screen and (min-width: 1920px) {
  .focus{
    .banner {
      .inner{
        .text-wrap{
          .slogn{
            font-size:140px;
            padding-bottom:80px;
          }
          .info{
            font-size:40px;
            line-height: 80px;
            font-weight: 400;
          }
        }
        .btn{
          a{
            margin-top:10px;
            padding:10px 40px;
            font-size:16px;
          }
        }
        .advantage{
          li{
            transform:scale(2);
            margin-right:220px;
            &:last-child{
              margin-right:0;
            }
          }
        }
      }
    }
  }
}
</style>
